var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-main-content", attrs: { type: "primary" } },
    [
      _c("div", { staticClass: "details-view" }, [
        _c("div", { staticClass: "main-content" }, [
          _c(
            "div",
            {
              staticClass: "operations",
              staticStyle: { "margin-bottom": "5px" }
            },
            [
              _c("div", { staticStyle: { display: "flex" } }, [
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.action === "look",
                        expression: "action==='look'"
                      }
                    ]
                  },
                  [
                    _c(
                      "el-button",
                      {
                        staticClass: "can-operate",
                        attrs: { no: "back", type: "primary" },
                        on: { click: _vm.goBack }
                      },
                      [_vm._v(_vm._s(_vm.$t("common.btn.back")))]
                    ),
                    _vm.$checkPermission(["button_cabinManagement_edit"])
                      ? _c(
                          "el-button",
                          {
                            attrs: { no: "edit", type: "primary" },
                            on: {
                              click: function($event) {
                                return _vm.toEdit()
                              }
                            }
                          },
                          [_vm._v(_vm._s(_vm.$t("common.btn.edit")) + " ")]
                        )
                      : _vm._e(),
                    _c(
                      "el-button",
                      {
                        attrs: { no: "Clone", type: "primary" },
                        on: {
                          click: function($event) {
                            return _vm.toClone()
                          }
                        }
                      },
                      [_vm._v(_vm._s(_vm.$t("SeaExport.Clone")) + " ")]
                    )
                  ],
                  1
                ),
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: ["edit", "add"].includes(_vm.action),
                        expression: "['edit', 'add'].includes(action)"
                      }
                    ],
                    staticClass: "btn-group-edit",
                    staticStyle: { "border-left": "none" }
                  },
                  [
                    _c(
                      "el-button",
                      {
                        attrs: { no: "save", type: "success" },
                        on: { click: _vm.saveHandler }
                      },
                      [_vm._v(_vm._s(_vm.$t("common.btn.save")))]
                    ),
                    _c(
                      "el-button",
                      {
                        attrs: { no: "cancel", type: "success" },
                        on: {
                          click: function($event) {
                            _vm.cancelEdit(function() {
                              _vm.againShow("look")
                            })
                          }
                        }
                      },
                      [_vm._v(_vm._s(_vm.$t("common.btn.cancel")))]
                    )
                  ],
                  1
                ),
                _c(
                  "div",
                  {
                    staticClass: "right-tip",
                    staticStyle: {
                      "padding-left": "20px",
                      "font-size": "20px",
                      color: "red",
                      width: "200px",
                      overflow: "hidden"
                    }
                  },
                  [_c("span", [_vm._v(_vm._s(_vm.allocationStatusLabel))])]
                )
              ])
            ]
          ),
          _c(
            "div",
            { staticClass: "tabs-container" },
            [
              _c(
                "el-tabs",
                {
                  staticStyle: { width: "100%" },
                  attrs: { type: "card" },
                  on: { "tab-click": _vm.handleTabClick },
                  model: {
                    value: _vm.activeTabName,
                    callback: function($$v) {
                      _vm.activeTabName = $$v
                    },
                    expression: "activeTabName"
                  }
                },
                [
                  _c(
                    "el-tab-pane",
                    {
                      attrs: {
                        label: _vm.$t("CargoMsg.Cargo_Basic"),
                        name: "tabBasic",
                        lazy: true
                      }
                    },
                    [
                      _c("tab-basic", {
                        ref: "tabBasic",
                        attrs: { context: _vm.context, action: _vm.action }
                      })
                    ],
                    1
                  ),
                  _vm.action !== "add"
                    ? _c(
                        "el-tab-pane",
                        {
                          attrs: {
                            name: "tabFileHistory",
                            label: _vm.$t("SeaExport.FileHistory"),
                            lazy: true
                          }
                        },
                        [
                          _c("tab-file-history", {
                            ref: "tabFileHistory",
                            attrs: { context: _vm.context }
                          })
                        ],
                        1
                      )
                    : _vm._e()
                ],
                1
              )
            ],
            1
          )
        ])
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }